<template>
  <vs-row v-if="data">
    <vs-col vs-w="12" class="p-3">
      <demographics-category-card :data="data" :category="'PROFESSIONS'"
                                  :colors="['#001f54', '#00316b', '#004582', '#005998', '#006daf', '#0083c7', '#0299df', '#1baff6', '#49c6ff', '#6adeff', '#87f6ff']"/>
    </vs-col>

    <vs-col vs-w="12" class="p-3">
      <demographics-category-card :data="data" :category="'BUSINESS_UNITS'"
                                  :colors="['#2e0059', '#480971', '#5c2086', '#71349a', '#8748b0', '#9c5cc6', '#b270dc', '#c985f2', '#e19cfe', '#f8b5ff', '#ffd5ff']"/>
    </vs-col>

    <vs-col vs-w="12" class="p-3">
      <demographics-category-card :data="data" :category="'GENDER'" :colors="['#002900', '#004e04', '#007526', '#039f4b', '#2cca71', '#62f498']"/>
    </vs-col>

    <vs-col vs-w="12" class="p-3">
      <demographics-category-card :data="data" :category="'LOCALES'" :colors="['#5a1300', '#893d00', '#bc6709', '#f19335', '#ffd375']"/>
    </vs-col>
  </vs-row>
</template>

<script>

import DemographicsCategoryCard from './graphs/demographics-category-card';
import {ResourceImpl} from 'hal-client';
import Vue from 'vue';

export default {
  name: 'analysis-demographics',
  components: {DemographicsCategoryCard},
  props: {
    resource: ResourceImpl,
    date: String,
    filters: Object,
    bus: Vue
  },
  data () {
    return {data: null};
  },
  created () {
    this.bus.$on('refresh', this.refresh);
  },
  mounted () {
    this.refresh();
  },
  destroyed () {
    this.bus.$off('refresh', this.refresh);
  },
  methods: {
    refresh () {
      if (this.resource.$has('demographics')) {
        const params = {
          ...this.filters,
          date: this.date
        };
        this.resource.$request().$get('demographics', params).then(res => {
          this.data = res;
        });
      }
    }
  }
};
</script>

<style scoped>

</style>
